import React from "react";
import lodash from "lodash";
import { useAuth } from "@/hooks/useAuth";
import { removeArticles } from "@/utils/removeArticles";
import { ISearchJsonProps } from "@/types/endpoints/plans";
import { AddSvgToData } from "@/utils/SvgDictionaries/addSvgToData";
import { OrderArrayByClassification } from "@/utils/orderArrayReseach";
import {
  PlansService,
  IResponsePlans,
  IClassificationRequest,
} from "@/services/endpoints/plans";
import { shuffleArray } from "@/utils/shuffleArray";
import { useRouter } from "next/router";
import { Api } from "@/services/configs/axios";

interface ISearchTerms {
  data: any, isInitialOrder: boolean, isFinalOrder: boolean, isAlphaOrder: boolean
}

export interface IPlansContextProps {
  pagePlans: number;
  totalPlans: number;
  isLoading: boolean;
  isResearch: boolean;
  getAllError: boolean;
  plan: IResponsePlans;
  isFinalOrder: boolean;
  typeOfPlans: string;
  setTypeOfPlans: React.Dispatch<React.SetStateAction<string>>;
  isAlphaOrder: boolean;
  getAllerror404: boolean;
  isInitialOrder: boolean;
  plans: IResponsePlans[];
  errorGetOnePlan: boolean;
  inputResearchText: string;
  SearchPlansError: boolean;
  orderPlansByAlpha: () => void;
  orderPlansByFinalYear: () => void;
  handleGetOnePlan: (id: any) => void;
  orderPlansByInitialYear: () => void;
  handleSearchPlans: (data: ISearchTerms) => void;
  handleClearAllSearchInputs: () => void;
  searchJsonTerms: Record<string, unknown>;
  handleLoadMore: (pageNumber: number) => void;
  setSearchJsonTerms: React.Dispatch<
    React.SetStateAction<Record<string, unknown>>
  >;
  handleGetAllPlans: (pageNumber: number) => void;
  handleSearchTerm: (data: ISearchJsonProps) => void;
  setPagePlans: React.Dispatch<React.SetStateAction<number>>;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setIsResearch: React.Dispatch<React.SetStateAction<boolean>>;
  setGetAllError: React.Dispatch<React.SetStateAction<boolean>>;
  setIsFinalOrder: React.Dispatch<React.SetStateAction<boolean>>;
  setIsAlphaOrder: React.Dispatch<React.SetStateAction<boolean>>;
  setIsInitialOrder: React.Dispatch<React.SetStateAction<boolean>>;
  setPlans: React.Dispatch<React.SetStateAction<IResponsePlans[]>>;
  setInputResearchText: React.Dispatch<React.SetStateAction<string>>;
  SETNTPLANS: React.Dispatch<any>
  NTPLANS: any
}

export const PlansContext = React.createContext({} as IPlansContextProps);

interface IProps {
  children: React.ReactNode;
}

export const PlansContextProvider: React.FC<IProps> = ({ children }) => {
  const { authenticated } = useAuth();
  const plansService = React.useMemo(() => new PlansService(), []);
  const {
    getAllPlans,
    searchPlans,
    getOnePlan,
    getClassificationPlans,
    searchQueryPlans,
  } = plansService;

  //armazena um plano
  const [plan, setPlan] = React.useState<IResponsePlans>();
  const [typeOfPlans, setTypeOfPlans] = React.useState("");

  // Array de planos
  const [plans, setPlans] = React.useState<IResponsePlans[]>([]);
  // estado de paginação dos planos - botão carregar mais
  const [pagePlans, setPagePlans] = React.useState(1);
  // total de planos vindo da api
  const [totalPlans, setTotalPlans] = React.useState(0);
  // Objeto que será enviado para o endpoint api/search
  const [searchJsonTerms, setSearchJsonTerms] = React.useState(
    {} as Record<string, unknown>
  );
  const [inputResearchText, setInputResearchText] = React.useState("");

  // estado que indica se foi realizado um filtrp
  const [isResearch, setIsResearch] = React.useState(false);
  // os três estados a baixo fazem referencia ao filtro de classificação na busca dos planos
  const [isFinalOrder, setIsFinalOrder] = React.useState(false);
  const [isAlphaOrder, setIsAlphaOrder] = React.useState(false);
  const [isInitialOrder, setIsInitialOrder] = React.useState(false);

  const [NTPLANS, SETNTPLANS] = React.useState<any>()

  const handleAddSvgToData = React.useCallback((data: any) => {
    return AddSvgToData(data) as any;
  }, []);

  const handleSearchQueryPlans = (data: any, record: any) => {
    searchQueryPlans({ data, record }).then(async (res) => {
      const { data } = res.data as any;
      const newArray = handleAddSvgToData(data);

      const updatedPlans = await Promise.all(
        newArray.map(async (plan: any) => {

          if (plan?.arquivosPlano && plan.arquivosPlano?.caminhoIcone) {
            const iconUrl = await fetchIcon(plan.arquivosPlano.caminhoIcone);
            return {
              ...plan,
              arquivosPlano: {
                ...plan.arquivosPlano,
                iconUrl,
              },
            };
          }

          return plan;
        })
      );

      // Utiliza um mapa para otimizar a busca dos planos atualizados
      const updatedPlansMap = new Map(updatedPlans.map(plan => [plan.id, plan]));
      const mergedPlans = newArray.map((plan: any) => updatedPlansMap.get(plan.id) || plan);

      const orderArray = OrderArrayByClassification({
        isAlphaOrder,
        isFinalOrder,
        isInitialOrder,
        newArray: mergedPlans as any,
      });
      setPlans(orderArray);
    });
  };

  const handleAlphaAndIninitalOrder = (record: any) => {
    getClassificationPlans(record).then(async (res) => {
      const { data } = res.data as any;
      const dataSvg = handleAddSvgToData(data);

      const updatedPlans = await Promise.all(
        dataSvg.map(async (plan: any) => {

          if (plan?.arquivosPlano && plan.arquivosPlano?.caminhoIcone) {
            const iconUrl = await fetchIcon(plan.arquivosPlano.caminhoIcone);
            return {
              ...plan,
              arquivosPlano: {
                ...plan.arquivosPlano,
                iconUrl,
              },
            };
          }

          return plan;
        })
      );

      // Utiliza um mapa para otimizar a busca dos planos atualizados
      const updatedPlansMap = new Map(updatedPlans.map(plan => [plan.id, plan]));
      const mergedPlans = dataSvg.map((plan: any) => updatedPlansMap.get(plan.id) || plan);

      const it = mergedPlans?.map((item: any) => ({
        ...item,
      }));
      const newArray = lodash.orderBy(
        it,
        ["anoInicialVigencia", "titulo"],
        ["desc", "asc"]
      );
      setPlans(newArray);
    });
  };

  const handleAlphaAndFinalOrder = (record: any) => {
    getClassificationPlans(record).then(async (res) => {
      const { data } = res.data as any;
      const dataSvg = handleAddSvgToData(data);
      const it = dataSvg?.map((item: any) => ({
        ...item,
      }));

      const updatedPlans = await Promise.all(
        it.map(async (plan: any) => {

          if (plan?.arquivosPlano && plan.arquivosPlano?.caminhoIcone) {
            const iconUrl = await fetchIcon(plan.arquivosPlano.caminhoIcone);
            return {
              ...plan,
              arquivosPlano: {
                ...plan.arquivosPlano,
                iconUrl,
              },
            };
          }

          return plan;
        })
      );

      // Utiliza um mapa para otimizar a busca dos planos atualizados
      const updatedPlansMap = new Map(updatedPlans.map(plan => [plan.id, plan]));
      const mergedPlans = dataSvg.map((plan: any) => updatedPlansMap.get(plan.id) || plan);

      const newArray = lodash.orderBy(
        mergedPlans,
        ["anoInicialVigencia", "titulo"],
        ["asc", "asc"]
      );
      setPlans(newArray);
    });
  };

  const handleInitialOrder = (record: any) => {
    getClassificationPlans(record).then(async (res) => {
      const { data } = res.data as any;
      const dataSvg = handleAddSvgToData(data);

      const updatedPlans = await Promise.all(
        dataSvg.map(async (plan: any) => {

          if (plan?.arquivosPlano && plan.arquivosPlano?.caminhoIcone) {
            const iconUrl = await fetchIcon(plan.arquivosPlano.caminhoIcone);
            return {
              ...plan,
              arquivosPlano: {
                ...plan.arquivosPlano,
                iconUrl,
              },
            };
          }

          return plan;
        })
      );

      // Utiliza um mapa para otimizar a busca dos planos atualizados
      const updatedPlansMap = new Map(updatedPlans.map(plan => [plan.id, plan]));
      const mergedPlans = dataSvg.map((plan: any) => updatedPlansMap.get(plan.id) || plan);

      const newArray = lodash.orderBy(mergedPlans, ["anoInicialVigencia"], ["asc"]);
      setPlans(newArray);
    });
  };

  const handleFinalOrder = (record: any) => {
    getClassificationPlans(record).then(async (res) => {
      const { data } = res.data as any;
      const dataSvg = handleAddSvgToData(data);

      const updatedPlans = await Promise.all(
        dataSvg.map(async (plan: any) => {

          if (plan?.arquivosPlano && plan.arquivosPlano?.caminhoIcone) {
            const iconUrl = await fetchIcon(plan.arquivosPlano.caminhoIcone);
            return {
              ...plan,
              arquivosPlano: {
                ...plan.arquivosPlano,
                iconUrl,
              },
            };
          }

          return plan;
        })
      );

      // Utiliza um mapa para otimizar a busca dos planos atualizados
      const updatedPlansMap = new Map(updatedPlans.map(plan => [plan.id, plan]));
      const mergedPlans = dataSvg.map((plan: any) => updatedPlansMap.get(plan.id) || plan);

      const newArray = lodash.orderBy(mergedPlans, ["anoInicialVigencia"], ["desc"]);
      setPlans(newArray);
    });
  };

  const handleAlphaOrder = (record: any) => {
    getClassificationPlans(record).then(async (res) => {
      const { data } = res.data as any;
      const dataSvg = handleAddSvgToData(data);
      const it = dataSvg?.map((item: any) => ({
        ...item,
      }));

      const updatedPlans = await Promise.all(
        dataSvg.map(async (plan: any) => {

          if (plan?.arquivosPlano && plan.arquivosPlano?.caminhoIcone) {
            const iconUrl = await fetchIcon(plan.arquivosPlano.caminhoIcone);
            return {
              ...plan,
              arquivosPlano: {
                ...plan.arquivosPlano,
                iconUrl,
              },
            };
          }

          return plan;
        })
      );

      // Utiliza um mapa para otimizar a busca dos planos atualizados
      const updatedPlansMap = new Map(updatedPlans.map(plan => [plan.id, plan]));
      const mergedPlans = dataSvg.map((plan: any) => updatedPlansMap.get(plan.id) || plan);

      // const newArray = lodash.orderBy(it, ["titulo"], ["asc"]);
      // Use a função de comparação personalizada para ordenar as palavras
      const palavrasOrdenadas = mergedPlans.sort((a: any, b: any) => {
        return a.titulo.localeCompare(b.titulo, undefined, {
          sensitivity: 'base',
          ignorePunctuation: true,
        });
      });
      setPlans(palavrasOrdenadas);

    });
  };
  // função que ordena os planos a partir do mais recenter
  const orderPlansByInitialYear = () => {
    
    if (isInitialOrder && isAlphaOrder) {
      const data = {
        date: "DESC",
        sort: "ASC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { date: "DESC", sort: "ASC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleAlphaAndIninitalOrder(data);
      return;
    }

    if (!isInitialOrder && isAlphaOrder) {
      const data = {
        sort: "ASC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { sort: "ASC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleAlphaOrder(data);
      return;
    }

    if (isInitialOrder && !isAlphaOrder) {
      const data = {
        date: "DESC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { date: "DESC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleInitialOrder(data);
    }


  };

  // função que ordena os planos a partir dos mais antigos
  const orderPlansByFinalYear = () => {
    if (isFinalOrder && isAlphaOrder) {
      const data = {
        date: "ASC",
        sort: "ASC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { date: "ASC", sort: "ASC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleAlphaAndFinalOrder(data);
      return;
    }

    if (isFinalOrder && !isAlphaOrder) {
      const data = {
        date: "ASC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { date: "ASC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleFinalOrder(data);
      return;
    }

    if (!isFinalOrder && isAlphaOrder) {
      const data = {
        sort: "ASC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { sort: "ASC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleAlphaOrder(data);
    }
  };

  // função que ordena os planos por ordem alfabética
  const orderPlansByAlpha = () => {
    if (isAlphaOrder && isFinalOrder) {
      const data = {
        date: "ASC",
        sort: "ASC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { sort: "ASC", date: "ASC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleAlphaAndFinalOrder(data);
      return;
    }

    if (!isAlphaOrder && isFinalOrder) {
      const data = {
        date: "ASC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { date: "ASC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleFinalOrder(data);
      return;
    }

    if (isAlphaOrder && isInitialOrder) {
      const data = {
        date: "ASC",
        sort: "ASC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { date: "ASC", sort: "ASC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleAlphaAndIninitalOrder(data);
      return;
    }

    if (!isAlphaOrder && isInitialOrder) {
      const data = {
        date: "DESC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { date: "DESC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleInitialOrder(data);
      return;
    }

    if (!isFinalOrder && !isInitialOrder && isAlphaOrder) {
      const data = {
        sort: "ASC",
        page: "1",
        size: String(plans.length),
      } as IClassificationRequest;

      if (Object.keys(searchJsonTerms).length > 0) {
        const record = { sort: "ASC" };
        handleSearchQueryPlans(searchJsonTerms, record);
        return;
      }

      handleAlphaOrder(data);
      return;
    }


    if (!isInitialOrder && !isFinalOrder && !isAlphaOrder) {
      const newArray = lodash.orderBy(plans, ["id"], ["desc"]);
      setPlans(newArray);
      return
    }

    if ((!isInitialOrder && !isAlphaOrder) && (Object.keys(searchJsonTerms).length > 0)) {
      const orderArray = lodash.orderBy(plans as any, [i => i?.hits?.length], ['desc']);
      setPlans(orderArray);
      return;
    }

  };

  // estado que controla o efeito skeleton dos planos em relação as requisições
  const [isLoading, setIsLoading] = React.useState(false);
  // estado que controla se houve um erro na requisição getAllPlans
  const [getAllError, setGetAllError] = React.useState(false);
  // estado que controla um erro 404 na requisição getAllPlans
  const [getAllerror404, setGetAllError404] = React.useState(false);
  const [errorGetOnePlan, setErrorGetOnePlan] = React.useState(false);
  // Função que busca todos os planos, é usada na primeira renderização

  const handleGetAllPlans = React.useCallback(
    (pageNumber: number) => {
      setIsLoading(true);
      setIsResearch(false);
      getAllPlans(pageNumber)
        .then((res) => {
          const { data, total } = res.data as any;
          setTotalPlans(total);
          const newArray = handleAddSvgToData(data) as IResponsePlans[];
          const orderArray = OrderArrayByClassification({
            isAlphaOrder,
            isFinalOrder,
            isInitialOrder,
            newArray,
          });
          setPlans(pageNumber === 1 ? shuffleArray(orderArray) : orderArray);
        })
        .catch((e) => {
          setGetAllError(true);
          if (e?.response?.status === 404) {
            setGetAllError404(true);
          }
        })
        .finally(() => {
          setIsLoading(false);
          setGetAllError(false);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAlphaOrder, isFinalOrder, isInitialOrder]
  );

  // UseEffect da primeira renderização
  const router = useRouter();
  React.useEffect(() => {
    const path = router.pathname;
    const isPublicList = path.split("/").includes("planos") || path.split("/").includes("mapa_interativo");
    const isDashboard = path.split("/").includes("dashboard") || path.split("/").includes("/dashboard");

    if ((isPublicList) || (authenticated && isDashboard)) {
      handleGetAllPlans(pagePlans);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, router.pathname]);

  // função que busca apenas um plano, utilizada na página "plano/id"
  const handleGetOnePlan = React.useCallback((id?: string | string[]) => {
    const planId = Array.isArray(id) ? id[0] : id;
    if (!planId) return;

    setIsLoading(true);
    setErrorGetOnePlan(false);
    getOnePlan(planId)
      .then((res) => {
        const { data } = res.data as any;
        setPlan(data);
        setGetAllError404(false);
      })
      .catch(() => {
        setErrorGetOnePlan(true);
      })
      .finally(() => setIsLoading(false));
  }, [getOnePlan]);

  // estado que controla se ouve erro na requisição searchPlans
  const [SearchPlansError, setSearchPlansError] = React.useState(false);

  const fetchIcon = React.useCallback(async (iconPath: any) => {
    if (!iconPath) return null;
    try {
      const response = await Api.get(`final/download/${iconPath}`); // Exemplo de URL
      return response.data; // Supondo que a API retorna a URL completa do ícone
    } catch (error) {
      console.error("Erro ao buscar ícone:", error);
      return null;
    }
  }, []);

  // Função que busca os novos planos a partir do filtro lateral e barra de pesquisa
  const handleSearchPlans = React.useCallback(({ data, isAlphaOrder, isFinalOrder, isInitialOrder }: ISearchTerms) => {
    setIsLoading(true);
    setIsResearch(false);

    searchPlans(data)
      .then(async (res) => {
        const { data } = res.data as any;
        const newArray = handleAddSvgToData(data);

        const updatedPlans = await Promise.all(
          newArray.map(async (plan: any) => {

            if (plan?.arquivoPlano && plan.arquivoPlano?.caminhoIcone) {
              const iconUrl = await fetchIcon(plan.arquivoPlano.caminhoIcone);
              return {
                ...plan,
                arquivosPlano: {
                  ...plan.arquivoPlano,
                  iconUrl,
                },
              };
            }

            return plan;
          })
        );

        const updatedPlansMap = new Map(updatedPlans.map(plan => [plan.id, plan]));
        const mergedPlans = newArray.map((plan: any) => updatedPlansMap.get(plan.id) || plan);

        let orderArray: any = [];
        if (isAlphaOrder || isFinalOrder || isInitialOrder) {
          orderArray = OrderArrayByClassification({
            isAlphaOrder,
            isFinalOrder,
            isInitialOrder,
            newArray: mergedPlans as any,
          });
        } else {
          orderArray = lodash.orderBy(mergedPlans, [i => i?.hits?.length], ['desc']);
        }

        setPlans(orderArray);

      })
      .catch((e) => setSearchPlansError(true))
      .finally(() => {
        const initalPageState = 1;
        setIsLoading(false);
        setIsResearch(true);
        setPagePlans(initalPageState);
      });
  }, [fetchIcon, handleAddSvgToData, searchPlans]);

  // função que controla a busca no campo de pesquisa
  const handleSearchTerm = React.useCallback((data: ISearchJsonProps) => {
    const { query } = data;
    const item = query as string;

    setSearchJsonTerms((prev) => {
      const next = { ...prev, query: item };

      if (item?.length > 0) {
        handleSearchPlans({
          data: next,
          isAlphaOrder,
          isFinalOrder,
          isInitialOrder,
        });
      }

      return next;
    });
  }, [handleSearchPlans, isAlphaOrder, isFinalOrder, isInitialOrder]);

  // função responsável por carregar mais itens analisando os planos pré existentes - botão carregar mais
  const handleLoadMore = (pageNumber: number) => {
    setIsLoading(true);
    setIsResearch(false);
    getAllPlans(pageNumber === 1 ? pageNumber + 1 : pageNumber)
      .then(async (res) => {
        const { data } = res.data as any;
        const it = data;

        if (it?.length === 0) {
          setIsLoading(false);
          return;
        }

        const newArray = handleAddSvgToData(it) as IResponsePlans[];


        const updatedPlans = await Promise.all(
          newArray.map(async (plan: any) => {

            if (plan?.arquivosPlano && plan.arquivosPlano?.caminhoIcone) {
              const iconUrl = await fetchIcon(plan.arquivosPlano.caminhoIcone);
              return {
                ...plan,
                arquivosPlano: {
                  ...plan.arquivoPlano,
                  iconUrl,
                },
              };
            }

            return plan;
          })
        );

        const updatedPlansMap = new Map(updatedPlans.map(plan => [plan.id, plan]));
        const mergedPlans = newArray.map((plan: any) => updatedPlansMap.get(plan.id) || plan);

        setPlans((prev) => {
          const prevArray = [...prev];
          const prevIds = new Set(prevArray.map((obj) => obj.id));
          const uniqueNewArray = mergedPlans.filter((obj) => !prevIds.has(obj.id));
          const mergedArray = [...prevArray, ...uniqueNewArray];
          return mergedArray;
        });

      })
      .finally(() => setIsLoading(false));
  };

  const value = {
    plan,
    NTPLANS,
    SETNTPLANS,
    typeOfPlans,
    setTypeOfPlans,
    plans,
    setPlans,
    isLoading,
    pagePlans,
    isResearch,
    totalPlans,
    getAllError,
    isFinalOrder,
    setPagePlans,
    setIsLoading,
    isAlphaOrder,
    setIsResearch,
    getAllerror404,
    isInitialOrder,
    handleLoadMore,
    setGetAllError,
    setIsFinalOrder,
    setIsAlphaOrder,
    searchJsonTerms,
    errorGetOnePlan,
    SearchPlansError,
    handleGetOnePlan,
    handleSearchTerm,
    inputResearchText,
    orderPlansByAlpha,
    setIsInitialOrder,
    handleSearchPlans,
    handleGetAllPlans,
    setSearchJsonTerms,
    setInputResearchText,
    orderPlansByFinalYear,
    orderPlansByInitialYear,
  } as IPlansContextProps;

  return (
    <PlansContext.Provider value={value}>{children}</PlansContext.Provider>
  );
};
